// Mock data for fitness influencer portfolio

export const influencerData = {
  name: "Alex Morgan",
  tagline: "Fitness Content Creator & Brand Partner",
  headline: "I Don't Just Create Fitness Content",
  subheadline: "I Help Fitness Brands Convert Audiences Into Paying Customers",
  stats: {
    followers: "750K+",
    monthlyReach: "3M+",
    brandDeals: "100+",
    avgEngagement: "8.5%"
  },
  social: {
    instagram: "@alexmorgan.fit",
    tiktok: "@alexmorgan.fit",
    youtube: "Alex Morgan Fitness"
  }
};

export const viralContent = [
  {
    id: 1,
    title: "30-Day Transformation",
    type: "Transformation",
    views: "2.5M",
    image: "https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e",
    engagement: "9.2%"
  },
  {
    id: 2,
    title: "5-Minute Home HIIT",
    type: "Home Workout",
    views: "1.8M",
    image: "https://images.unsplash.com/photo-1551984427-6d77a1918093",
    engagement: "8.7%"
  },
  {
    id: 3,
    title: "Meal Prep Sunday",
    type: "Diet Tips",
    views: "1.2M",
    image: "https://images.pexels.com/photos/4720570/pexels-photo-4720570.jpeg",
    engagement: "7.9%"
  },
  {
    id: 4,
    title: "Leg Day Destroyer",
    type: "Gym Workout",
    views: "2.1M",
    image: "https://images.unsplash.com/photo-1595078475328-1ab05d0a6a0e",
    engagement: "9.5%"
  },
  {
    id: 5,
    title: "Functional Strength",
    type: "Training Tips",
    views: "1.5M",
    image: "https://images.pexels.com/photos/4720833/pexels-photo-4720833.jpeg",
    engagement: "8.1%"
  },
  {
    id: 6,
    title: "Protein Myths Busted",
    type: "Diet Tips",
    views: "3.2M",
    image: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438",
    engagement: "10.3%"
  }
];

export const brands = [
  { id: 1, name: "GymShark", category: "Apparel" },
  { id: 2, name: "MyProtein", category: "Supplements" },
  { id: 3, name: "FitBit", category: "Tech" },
  { id: 4, name: "Nike Training", category: "Apparel" },
  { id: 5, name: "Optimum Nutrition", category: "Supplements" },
  { id: 6, name: "Rogue Fitness", category: "Equipment" },
  { id: 7, name: "Lululemon", category: "Apparel" },
  { id: 8, name: "Under Armour", category: "Apparel" }
];

export const services = [
  {
    id: 1,
    title: "Sponsored Content",
    description: "High-engagement posts and stories featuring your brand with authentic integration",
    features: ["Instagram Reels & Posts", "TikTok Videos", "YouTube Integrations", "Multi-platform reach"],
    icon: "video"
  },
  {
    id: 2,
    title: "UGC for Ads",
    description: "Performance-driven user-generated content designed to convert viewers into customers",
    features: ["Ready-to-use ad content", "Multiple variations", "High ROI focus", "Commercial rights"],
    icon: "camera",
    highlight: true
  },
  {
    id: 3,
    title: "Fitness Programs",
    description: "Co-branded workout programs and challenges that drive engagement and sales",
    features: ["Custom program design", "Challenge hosting", "Community building", "Exclusive content"],
    icon: "trophy"
  },
  {
    id: 4,
    title: "Affiliate Promotions",
    description: "Strategic affiliate marketing with proven conversion rates and audience trust",
    features: ["Honest reviews", "Discount code promotions", "Ongoing partnerships", "Performance tracking"],
    icon: "trending-up"
  },
  {
    id: 5,
    title: "Brand Ambassador",
    description: "Long-term partnerships representing your brand values and driving sustained growth",
    features: ["Exclusive representation", "Quarterly campaigns", "Event appearances", "Product development input"],
    icon: "award"
  }
];

export const testimonials = [
  {
    id: 1,
    type: "client",
    name: "Sarah K.",
    role: "Client",
    content: "Lost 25 lbs following Alex's program! The transformation wasn't just physical - I gained confidence and a sustainable lifestyle.",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80",
    result: "-25 lbs in 12 weeks"
  },
  {
    id: 2,
    type: "brand",
    name: "Marcus Chen",
    role: "Marketing Director, FitFuel Nutrition",
    content: "Alex's UGC content generated a 340% ROI on our ad spend. The authenticity and engagement rates are unmatched.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e",
    result: "340% ROI"
  },
  {
    id: 3,
    type: "client",
    name: "Mike Thompson",
    role: "Client",
    content: "Gained 15 lbs of muscle while staying lean. Alex's approach to training and nutrition is science-backed and results-driven.",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
    result: "+15 lbs muscle"
  },
  {
    id: 4,
    type: "brand",
    name: "Jessica Williams",
    role: "CEO, ActiveWear Co.",
    content: "Our partnership with Alex drove 50K+ new customers in Q4 alone. The content quality and audience alignment are perfect.",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
    result: "50K+ new customers"
  },
  {
    id: 5,
    type: "client",
    name: "Emily Rodriguez",
    role: "Client",
    content: "After 2 years of trying different programs, Alex's approach finally clicked. Down 40 lbs and maintaining effortlessly!",
    image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb",
    result: "-40 lbs sustained"
  },
  {
    id: 6,
    type: "brand",
    name: "David Park",
    role: "Brand Manager, PowerGym Equipment",
    content: "Alex's sponsored content series generated 2M impressions with an 11% engagement rate. Best influencer partnership we've had.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d",
    result: "2M impressions, 11% engagement"
  }
];

export const aboutStory = {
  title: "From Struggling to Thriving",
  story: "5 years ago, I was 60 lbs overweight, stuck in a cycle of fad diets and inconsistent workouts. The transformation wasn't just about losing weight - it was about building a sustainable lifestyle and helping others do the same. Today, I've helped 10,000+ people transform their bodies and partnered with 100+ fitness brands to create content that converts.",
  achievements: [
    "Certified Personal Trainer (NASM)",
    "Nutrition Specialist",
    "750K+ Social Media Following",
    "100+ Successful Brand Partnerships",
    "10,000+ Client Transformations"
  ]
};
